import React from "react";
import { Typography } from "@mui/material";

import WorkOrderLabel from "./WorkOrderLabel";
import { NotesStack, StyledBaseBox } from "./styles";
import { getTestingCounts, getWorkOrderInstructions } from "./helper";

const INJECTION_TYPES = ["HAND", "SIDE", "TOP", "AUTOMATIC"];
const cupTypes = ["", "Ounces", "Regular", "Filter"];

const WorkOrderWax = ({ data }) => {
  // Get Instructions
  let wax = getWorkOrderInstructions(data, 1);
  let assembly = getWorkOrderInstructions(data, 12);

  // Get Hours
  let totalWaxCycleTime =
    Math.round(wax?.routing?.reduce((tol, curr) => tol + curr?.cycleTime, 0)) ||
    0;
  let totalPattern = (totalWaxCycleTime * data?.quantity) / 60;
  let patternHrs = Math.round(totalPattern * 100) / 100;

  const injectionType = INJECTION_TYPES[wax?.config?.injectType || 0];

  const testing = data?.testing || [];
  const mappedTesting = getTestingCounts(testing);

  return (
    <StyledBaseBox columns={4} gridAutoRows="15px">
      <Typography variant="boldCaptionMain">Wax Department</Typography>
      <WorkOrderLabel label="INJECT TYPE" value={injectionType} />
      <NotesStack col={1} row={3}>
        <Typography variant="caption" fontWeight={400} lineHeight="14px">
          Testing: <strong>{mappedTesting}</strong>
        </Typography>
      </NotesStack>
      <WorkOrderLabel label="TREE" value={data?.tree?.name} valueBold />

      <WorkOrderLabel label="LOT #" value={data?.lotNumber} />
      <WorkOrderLabel label="PATTERN" value={`${totalWaxCycleTime} mins`} />
      {/* <div /> */}
      <WorkOrderLabel label="#TREE(S)" value={data?.trees} valueBold />

      <WorkOrderLabel
        label="CUP"
        value={`${wax?.config?.cupSize} ${cupTypes[wax?.config?.cupType]}`}
      />
      <WorkOrderLabel label="TOTAL PATTERN" value={`${patternHrs} hrs`} />
      {/* <div /> */}
      <WorkOrderLabel label="#PER TREE" value={data?.details?.partsPerTree} valueBold />

      <NotesStack col="3">
        <Typography variant="caption" fontWeight={400} lineHeight="14px">
          WAX INST: <strong>{wax?.notes}</strong>
        </Typography>
      </NotesStack>
      <WorkOrderLabel label="SETUP" value={assembly?.config?.setup} valueBold />
      <WorkOrderLabel label="#SET-UP TIME" />

      <NotesStack col="4">
        <Typography variant="caption" fontWeight={400} lineHeight="14px">
          SETUP INST: <strong>{assembly?.notes}</strong>
        </Typography>
      </NotesStack>
    </StyledBaseBox>
  );
};

export default WorkOrderWax;
